<template>
  <div class="falling">
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cont: 0
    }
  },

  methods: {
    generateDrops() {
      const emojis = ["❄️","🦌","🎁","🎄","🔔","🎅"]

      const drop = document.createElement("div");
      drop.classList.add("g247-drop")
      drop.innerText = emojis[Math.floor(Math.random() * emojis.length)]
      drop.style.left = Math.random() * 100 + "vw";
      drop.style.animationDuration = Math.random() * 2 + 1 + "s"
      document.getElementById('app').appendChild(drop)

      this.cont++
    }
  },
  
  mounted() {
    const self = this

    const limit = 30

    const interval = setInterval(() => {
      this.generateDrops()

      if (this.cont > limit) {
        setTimeout(function() {
          const elements = document.getElementsByClassName('g247-drop');
          while(elements.length > 0){
              elements[0].parentNode.removeChild(elements[0]);
          }

          self.$emit('end')

        }, 3000)

        return clearInterval(interval)
      }
    }, 100)
  }
}
</script>

<style lang="scss">
.g247-drop {
  position: fixed;
  z-index: 100;
  top: -1vh;
  font-size: 2rem;
  transform: translateY(0);
  animation: fall 3s linear forwards;
  
  //Remove ability to highlight drops
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none; 
        -ms-user-select: none; 
            user-select: none; 
}

@keyframes fall {
  to{
    transform: translateY(101vh);
  }
}
</style>